import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Controller,Body,Req, Query, Post } from '@nestjs/common';
import { ApiHeader, ApiQuery, ApiTags} from '@nestjs/swagger';
import { PostActivityDTO} from './dto/post-activity.dto';
import { PostActivityService } from './post-activity.service';
import { PostActivityResponseModel, PostActivitysharedResponseModel  } from './dto/post-activity-response.model';
import { PostActivitySharedDTO } from './dto/Post-activity-shared.dto';

@ApiTags('PostActivity')
@Controller('post-activity')
export class PostActivityController {
    constructor(
        private postActivityService: PostActivityService
    ){}
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createPostActivity')
    @ApiQuery({name:'apiVersion'})
    async createPostActivity(@Query() queryParams,@Body() postActivityDto: PostActivityDTO,@Req() request:Request):Promise<PostActivityResponseModel>{
        try {
            if(queryParams.apiVersion == 1) {
                return await this.postActivityService.createPostActivity(postActivityDto, request);
            } else {
                return await this.postActivityService.createPostActivity(postActivityDto, request);
            }            
        } catch(error) {
            return errorHandler(PostActivityResponseModel, error);
        }
    }
    @Post('/sharePost')
    @ApiQuery({name:'apiVersion'})
    async createPostActivityshared(@Query() queryParams,@Body() PostActivitySharedDTO:PostActivitySharedDTO,@Req() request:Request):Promise<PostActivitysharedResponseModel>{
        try {          
            return await this.postActivityService.createPostActivityshared(PostActivitySharedDTO,queryParams, request);
        } catch(error) {
            return errorHandler(PostActivitysharedResponseModel, error);
        }
    }

}